<template>
  <el-dialog :close-on-click-modal="false" :visible="visible" title="定点备案" width="80rem" @close="close">
    <el-row slot="title">
      <el-col class="flex justify_center">
        2503.人员慢特病备案
        <medicare-card @emit="getMedicareInfo" />
      </el-col>
    </el-row>
    <el-form ref="editor" label-width="10.5rem" size="small" :rules="rules" label-position="right" :model="entity" @submit.native.prevent style="padding-right:2rem;">
      <el-row :gutter="12">
        <el-col :span="8">
          <el-form-item label="人员编号" prop="psn_no">
            <el-input maxlength="30" show-word-limit v-model="entity.psn_no" placeholder="人员编号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="人员证件类型" prop="psn_cert_type">
            <dict-select size="small" v-model="entity.psn_cert_type" isMed dict-type="psn_cert_type" placeholder="人员证件类型" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="人员证件号码" prop="certno">
            <el-input maxlength="30" show-word-limit v-model="entity.certno" placeholder="人员证件号码"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="人员姓名" prop="psn_name">
            <el-input maxlength="30" show-word-limit v-model="entity.psn_name" placeholder="人员姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别" prop="gend">
            <dict-select size="small" v-model="entity.gend" isMed dict-type="gend" placeholder="性别" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出生日期" prop="brdy">
            <el-date-picker v-model="entity.brdy" type="date" placeholder="出生日期" value-format="yyyy-MM-dd" style="width:100%">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="国籍" prop="naty">
            <dict-select size="small" v-model="entity.naty" isMed dict-type="nat_regn_code" placeholder="国籍" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话" prop="tel">
            <el-input maxlength="50" show-word-limit v-model="entity.tel" placeholder="联系电话"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系地址" prop="addr">
            <el-input maxlength="200" show-word-limit v-model="entity.addr" placeholder="联系地址"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="参保所属医保区划" prop="insu_admdvs">
            <el-input maxlength="30" show-word-limit v-model="entity.insu_admdvs" placeholder="参保所属医保区划"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="险种类型" prop="insutype">
            <dict-select size="small" v-model="entity.insutype" isMed dict-type="insutype" placeholder="险种类型" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="人员类别" prop="psn_type">
            <dict-select size="small" v-model="entity.psn_type" isMed dict-type="psn_type" placeholder="人员类别" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="门慢特病种目录代码" prop="opsp_dise_code" style="position: relative">
            <el-input
              maxlength="30"
              v-model="entity.opsp_dise_code"
              placeholder="门慢门特病种目录代码"
              style="float: left; width: 180px"
              show-word-limit>
            </el-input>
            <el-button
              @click="meta.showMedOpspDise=true"
              title="选择"
              icon="el-icon-search"
              style="position: absolute; right: 0; z-index: 888">
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="门慢特病种名称" prop="opsp_dise_name">
            <el-input maxlength="300" show-word-limit v-model="entity.opsp_dise_name" placeholder="门慢门特病种名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="参保机构医保区划" prop="insu_optins">
            <el-input maxlength="6" show-word-limit v-model="entity.insu_optins" placeholder="参保机构医保区划"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="鉴定定点医药机构编号" prop="ide_fixmedins_no">
            <el-input maxlength="30" show-word-limit v-model="entity.ide_fixmedins_no" readonly @focus="meta.showMedHospital=true" placeholder="鉴定定点医药机构编号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="鉴定定点医药机构名称" prop="ide_fixmedins_name">
            <el-input maxlength="200" show-word-limit v-model="entity.ide_fixmedins_name" placeholder="鉴定定点医药机构名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="医院鉴定日期" prop="hosp_ide_date">
            <el-date-picker v-model="entity.hosp_ide_date" type="date" placeholder="医院鉴定日期" value-format="yyyy-MM-dd" style="width:100%">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="诊断医师姓名" prop="diag_dr_name">
            <doctors-selector v-model="entity.diag_dr_name" @change="(val) => entity.diag_dr_codg = val" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="诊断医师编码" prop="diag_dr_codg">
            <el-input maxlength="30" show-word-limit v-model="entity.diag_dr_codg" placeholder="请先选择医师" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="业务类型标志" prop="biz_type_flag">
            <el-select v-model="entity.biz_type_flag" placeholder="请选择" style="width: 100%">
              <el-option label="一类门特" value="1"></el-option>
              <el-option label="二类门特" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="开始日期" prop="begndate">
            <el-date-picker v-model="entity.begndate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" style="width:100%">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="结束日期" prop="enddate">
            <el-date-picker v-model="entity.enddate" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" style="width:100%">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="病情摘要及诊断" prop="cond_abst_diag">
            <el-input v-model="entity.cond_abst_diag" placeholder="病情摘要及诊断"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="待遇类型" prop="med_trt_type">
            <dict-select size="small" :text.sync="entity.med_trt_type_name" v-model="entity.med_trt_type" isMed dict-type="med_type_14" placeholder="待遇类型" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="病种名称" prop="med_trt_type_name">
            <el-input v-model="entity.med_trt_type_name" placeholder="病种名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="诊治方案及项目构成" prop="trt_schm">
            <el-input v-model="entity.trt_schm" placeholder="诊治方案及项目构成"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="主任医师" prop="chfdr">
            <doctors-selector v-model="entity.chfdr" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="科室" prop="dept_code">
            <dict-select v-model="entity.dept_code" dict-type="Dept" clearable @change="changeDept" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="科室电话" prop="dept_tel">
            <el-input v-model="entity.dept_tel" placeholder="科室电话"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="医院意见" prop="hosp_opnn">
            <el-input v-model="entity.hosp_opnn" placeholder="医院意见"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="公司名称">
            <el-input v-model="entity.emp_name" placeholder="公司名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="公司编码">
            <el-input v-model="entity.emp_no" placeholder="公司名称"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item label="科室名称" prop="dept_name">
            <el-input v-model="entity.dept_name" placeholder="科室名称"></el-input>
          </el-form-item>
        </el-col> -->
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">
        取 消
      </el-button>
      <el-button type="primary" @click="save" :loading="submitLoad">
        确 定
      </el-button>
    </div>
    <hospital-select :visible.sync="meta.showMedHospital" fixmedins-type="1" :fixmedins-code.sync="entity.ide_fixmedins_no" :fixmedins-name.sync="entity.ide_fixmedins_name"></hospital-select>
    <opsp-dise-select :visible.sync="meta.showMedOpspDise" :code.sync="entity.opsp_dise_code" :name.sync="entity.opsp_dise_name"></opsp-dise-select>
  </el-dialog>
</template>

<script>
import api from '@/common/api';

const medicareCard = () => import(/* webpackChunkName: 'medicareCard' */ '../../components/_medcom/medicareCard');
const doctorsSelector = () => import(/* webpackChunkName: 'doctorsSelector' */ '../../components/_com/doctorsSelector');

export default {
  name: 'chronic',
  components: {
    medicareCard,
    doctorsSelector
  },
  props: {
    visible: { type: Boolean, default: false },
    value: {},
  },
  data () {
    const { hospitalInfo } = this.$store.state;
    const { inputRuleFn, selectRuleFn } = this.$utils;
    return {
      rules: {
        psn_no: inputRuleFn('人员编号'),
        psn_cert_type: selectRuleFn('人员证件类型'),
        certno: inputRuleFn('人员证件号码'),
        psn_name: inputRuleFn('人员姓名'),
        insu_admdvs: inputRuleFn('参保所属医保区划'),
        insutype: selectRuleFn('险种类型'),
        opsp_dise_code: [{ required: true, message: '请输入门慢特病种目录代码', trigger: 'change' }],
        opsp_dise_name: [{ required: true, message: '请输入门慢特病种名称', trigger: 'change' }],
        tel: [{ required: true, message: '请输入联系电话', trigger: 'blur' },
          {
            pattern: /^[1]([3-9])[0-9]{5,9}$/,
            // pattern: /^[0-9]{5,20}$/, // 20220624应需求，临时改为5位数字以上
            message: '格式错误',
            trigger: 'blur'
          }
        ],
        addr: inputRuleFn('联系地址'),
        insu_optins: inputRuleFn('参保机构医保区划'),
        ide_fixmedins_no: inputRuleFn('鉴定定点医药机构编号'),
        ide_fixmedins_name: inputRuleFn('鉴定定点医药机构名称'),
        hosp_ide_date: selectRuleFn('医院鉴定日期'),
        diag_dr_codg: [{ required: true, message: '请输入诊断医师编码', trigger: 'change' }],
        diag_dr_name: selectRuleFn('诊断医师姓名'),
        begndate: selectRuleFn('开始日期'),
        enddate: selectRuleFn('结束日期'),
        biz_type_flag: selectRuleFn('业务类型标志'),
        med_trt_type: selectRuleFn('待遇类型'),
        brdy: selectRuleFn('出生日期'),
        med_trt_type_name: inputRuleFn('病种名称'),
        cond_abst_diag: inputRuleFn('病情摘要及诊断'),
        trt_schm: inputRuleFn('诊治方案及项目构成'),
        hosp_opnn: inputRuleFn('医院意见'),
        chfdr: selectRuleFn('主任医师'),
        gend: selectRuleFn('性别'),
        naty: selectRuleFn('国籍'),
        dept_code: selectRuleFn('科室'),
        dept_name: inputRuleFn('科室名称'),
        dept_tel: inputRuleFn('科室电话'),
        psn_type: selectRuleFn('人员类别'),
      },
      meta: {
        showMedHospital: false,
        showMedOpspDise: false
      },
      submitLoad: false,
      entity: {
        psn_no: '', // 44010000001023935144
        psn_cert_type: '',
        certno: '', // 44010319870629151X
        psn_name: '',
        insu_admdvs: hospitalInfo.mdtrtareaAdmvs, // "440100",
        insutype: '', // 310
        opsp_dise_code: '',
        opsp_dise_name: '',
        tel: '',
        addr: '',
        insu_optins: hospitalInfo.mdtrtareaAdmvs, // "440100",
        ide_fixmedins_no: hospitalInfo.fixmedinsCode, // "H44011100768",
        ide_fixmedins_name: hospitalInfo.fixmedinsName, // "嘉禾街望岗社区卫生服务站",
        hosp_ide_date: '',
        diag_dr_codg: '',
        diag_dr_name: '',
        begndate: '',
        enddate: '',
        biz_type_flag: '', // 1
        med_trt_type: '',
        brdy: '',
        med_trt_type_name: '',
        cond_abst_diag: '',
        trt_schm: '',
        hosp_opnn: '',
        chfdr: '',
        gend: '',
        naty: '',
        emp_name: '',
        emp_no: '',
        dept_code: '',
        dept_name: '',
        dept_tel: '',
        psn_type: '' // 301
      },
      header: null // 医保请求体里的header
    }
  },
  created () {
    this.initFn();
  },
  methods: {
    async initFn () {
      await this.$utils.init();
      const serverTime = this.$utils.fmtDate(this.$utils.serverTime);
      this.entity.begndate = serverTime;
      this.entity.enddate = serverTime;
      const { value } = this;
      const { cardInfo } = this.$store.state;
      if (value && value.name) {
        this.entity.psn_no = value.insuranceNo;
        this.entity.psn_name = value.name;
        this.entity.med_trt_type = ''; // 110
        this.entity.tel = value.phone;
        this.entity.addr = value.nativePlaceProvince + value.nativePlaceCity + value.nativePlaceDistrict + value.nativePlaceStreet + value.address;
        this.entity.psn_cert_type = value.idType === 'SF' ? '01' : value.idType;
        this.entity.certno = value.idNo;
        this.entity.brdy = value.birthday;
        this.entity.gend = value.gender;
        this.entity.naty = (value.nationality === 'CHINA' || !value.nationality) ? 'CHN' : value.nationality;
        this.entity.insutype = value.insuranceType;
        this.entity.emp_name = value.company || '';
        // this.$set(this.entity, 'psn_type', this.value.insurance_type)
      } else if (cardInfo.psn_no) {
        // 刷卡了
        this.entity.psn_no = cardInfo.psn_no;
        this.entity.psn_name = cardInfo.psn_name;
        this.entity.psn_cert_type = cardInfo.psn_cert_type;
        this.entity.certno = cardInfo.certno;
        this.entity.brdy = cardInfo.brdy;
        this.entity.gend = cardInfo.gend;
        // this.entity.naty = 'CHN';
        this.entity.insutype = cardInfo.insutype;
        this.entity.insu_admdvs = cardInfo.header.insuplc_admdvs; // 刷卡时，这里取刷卡人的 参保所属医保区划
      }
    },
    close () {
      this.$emit('update:visible', false)
    },
    changeDept(code, row) {
      this.entity.dept_name = row.name
    },
    save () {
      this.$refs.editor.validate().then(valid => {
        this.submitLoad = true;
        api.exec('2503', { data: this.entity }, this.header)
          .then(res => {
            this.$message.success('慢特病备案成功');
            this.close();
          })
          .catch((err) => {
            this.$message({
              type: 'error',
              message: err || '请求或接口异常',
              showClose: true,
              duration: 15000
            });
          })
          .finally(() => this.submitLoad = false);
      }).catch((err) => {});
    },
    // 获取刷卡后的数据
    getMedicareInfo(data) {
      // console.log(2424, data, data.baseinfo);
      for (let i in data.baseinfo) {
        if (this.entity.hasOwnProperty(i)) {
          this.entity[i] = data.baseinfo[i];
        }
        this.entity.naty = ''; // 20221201，经过测试验证，不取读卡的民族01
      }
      this.header = data.header;
      this.entity.insu_admdvs = data.header.insuplc_admdvs; // 刷卡时，这里取刷卡人的 参保所属医保区划
    }
  }
}
</script>
